/**
 * Constantes del Behavioral Health Dashboard
 * BH severity levels, colores, SUD types, helpers
 */

// ─── BH Health Status Colors (7 niveles de severidad) ────────────
export const BH_STATUS_COLORS = {
  "SEVERELY COMPLEX":        { bg: "#FFEBEE", text: "#B71C1C", border: "#FFCDD2", dot: "#B71C1C" },
  "COMPLEX CHRONIC - SPMI":  { bg: "#FFEBEE", text: "#D32F2F", border: "#FFCDD2", dot: "#D32F2F" },
  "COMPLEX CHRONIC - ANY BH":{ bg: "#FFF3E0", text: "#E65100", border: "#FFE0B2", dot: "#E65100" },
  "ACUTE":                   { bg: "#FFF3E0", text: "#FF9800", border: "#FFE0B2", dot: "#FF9800" },
  "AT RISK - SPMI":          { bg: "#FFF8E1", text: "#F9A825", border: "#FFF9C4", dot: "#FFC107" },
  "AT RISK - ANY BH":        { bg: "#E3F2FD", text: "#1976D2", border: "#BBDEFB", dot: "#1976D2" },
  "CHRONIC":                 { bg: "#E8F5E9", text: "#388E3C", border: "#C8E6C9", dot: "#388E3C" },
  "No Status":               { bg: "#F5F5F5", text: "#757575", border: "#E0E0E0", dot: "#757575" },
};

// ─── BH Severity Weight (para triage sort) ───────────────────────
export const BH_SEVERITY_WEIGHT = {
  "SEVERELY COMPLEX": 7,
  "COMPLEX CHRONIC - SPMI": 6,
  "COMPLEX CHRONIC - ANY BH": 5,
  "ACUTE": 4,
  "AT RISK - SPMI": 3,
  "AT RISK - ANY BH": 2,
  "CHRONIC": 1,
  "No Status": 0,
};

// ─── SUD Type Colors ─────────────────────────────────────────────
export const SUD_TYPE_COLORS = {
  "Drug Use Disorders":    { bg: "#FEE2E2", text: "#DC2626" },
  "Alcohol Use Disorders": { bg: "#FEF3C7", text: "#D97706" },
  "Opioid Disorder Flag":  { bg: "#FCE7F3", text: "#BE185D" },
  "Tobacco Use":           { bg: "#F3E8FF", text: "#7C3AED" },
};

// ─── Care Program Colors ─────────────────────────────────────────
export const CARE_PROGRAM_COLORS = {
  digital: { bg: "#EFF6FF", text: "#2563EB", label: "Digital Well-Being" },
  lucet:   { bg: "#F3E8FF", text: "#7C3AED", label: "Lucet BH Care" },
  both:    { bg: "#ECFDF5", text: "#059669", label: "Both Programs" },
  none:    { bg: "#FEF3C7", text: "#D97706", label: "No Program" },
};

// ─── BH Dashboard Theme Color ────────────────────────────────────
export const BH_THEME = {
  primary: "#7C3AED",
  primaryLight: "#A78BFA",
  primaryBg: "#F3E8FF",
  gradient: "linear-gradient(135deg, #7C3AED 0%, #A78BFA 100%)",
};

/**
 * Obtiene el peso de severidad de un BH Health Status.
 * @param {string|null} status
 * @returns {number}
 */
export const getBHSeverity = (status) => {
  if (!status) return 0;
  return BH_SEVERITY_WEIGHT[status] ?? 0;
};

/**
 * Obtiene los colores para un BH Health Status.
 * @param {string|null} status
 * @returns {{ bg, text, border, dot }}
 */
export const getBHStatusColors = (status) => {
  if (!status) return BH_STATUS_COLORS["No Status"];
  return BH_STATUS_COLORS[status] || BH_STATUS_COLORS["No Status"];
};

/**
 * Obtiene el color para un tipo de SUD.
 * @param {string} sudType
 * @returns {{ bg, text }}
 */
export const getSUDColor = (sudType) => {
  return SUD_TYPE_COLORS[sudType] || { bg: "#F1F5F9", text: "#64748B" };
};
